import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { BUTTON_RESET, C, FONT_BODY, FOCUS_RING, RADIUS } from "../../utils/designTokens";

/**
 * The 56px red Place order button, the amount due in a darker pill inside it.
 * The same button sits in the summary and in the phone's bottom bar, so both
 * always show one amount.
 */
function PlaceOrderButton({ amount, onClick, loading = false, label = "Place order" }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={loading}
      aria-label={loading ? "Placing your order" : `${label}, ${amount}`}
      sx={{
        ...BUTTON_RESET,
        display: "flex",
        alignItems: "center",
        justifyContent: loading ? "center" : "space-between",
        gap: 1.5,
        width: "100%",
        height: 56,
        boxSizing: "border-box",
        pl: 2.5,
        pr: 1,
        borderRadius: RADIUS.controlLg,
        bgcolor: C.red,
        color: "#FFFFFF",
        fontFamily: FONT_BODY,
        fontSize: 16,
        fontWeight: 700,
        transition: "background-color .15s ease",
        "&:hover": { bgcolor: C.redHover },
        "&:disabled": { bgcolor: C.redHover, cursor: "progress" },
        ...FOCUS_RING,
      }}
    >
      {loading ? (
        <>
          <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
          <span>Placing order</span>
        </>
      ) : (
        <>
          <span>{label}</span>
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              height: 40,
              px: 1.75,
              borderRadius: RADIUS.control,
              bgcolor: C.redDark,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {amount}
          </Box>
        </>
      )}
    </Box>
  );
}

export default React.memo(PlaceOrderButton);
